import { createContext } from 'react';
import { useFiltersContext } from '../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_SAMU,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { getUserSession } from '../../../../../../util/core/Session';
import config from '../../../../../../config/config';

export const RegulationChartsDataContext = createContext();

const RegulationChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const session = getUserSession();
    const profile = session?.user?.application_profile_id;
    const isAdm = profile === config.default_foreign_key.profiles.zellusAdmin;

    const filterParams = {
        ano: filters.ano?.value,
        ...(filters.mes?.value && { mes: filters.mes.value }),
        ...(isAdm && filters.cidade?.value && { city: filters.cidade.value })
    };

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SAMU.REGULATION_RESULTS,
            url: 'governanceroom/dashboardsamu/results/regulation-results'
        },
        filterParams
    );

    const chartData = data
        ? {
              medicalRegIndex: data?.medicalRegIndex ?? [],
              locationIndex: data?.locationIndex ?? [],
          }
        : {
              medicalRegIndex: [],
              locationIndex: []
          };

    return (
        <RegulationChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </RegulationChartsDataContext.Provider>
    );
};

export default RegulationChartsDataProvider;
